<template>
  <div>
   <componeyInfoCrad :customerCompany="customerCompany"/>
  </div>
</template>

<script>
import componeyInfoCrad from './components/componeyInfoCrad'
import { findCompanyMessage } from '@/api/personCenter/addressInfo/company'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['currentCustom'])
  },
  components: {
    componeyInfoCrad
  },
  data () {
    return {
      breadCrumbs: [{
        label: '首页'
      }, {
        label: '个人中心'
      }],
      customerCompany: {}
    }
  },
  methods: {
    onLoad () {
      findCompanyMessage(this.currentCustom.customerId).then(res => {
        this.customerCompany = res.data.data
      })
    }
  },
  created () {
    this.onLoad()
  }
}
</script>

<style lang="scss" scoped>
.myOwnOrder {
    width: 100%;
}
</style>
